import { WorkflowIcon } from "lucide-react";
import type { CmmdForgeAutomationRun } from "@cmmd-forge/contracts";

import { formatTaskDateTime } from "./taskDateTime";

export function ProjectTaskAutomationHistory(props: {
  readonly runs: readonly CmmdForgeAutomationRun[];
  readonly headingId: string;
}) {
  return (
    <section aria-labelledby={props.headingId} className="space-y-2">
      <h3 id={props.headingId} className="text-sm font-semibold text-foreground">
        Automation runs
      </h3>
      <ol className="divide-y divide-border border-y border-border">
        {props.runs.map((entry) => (
          <li key={entry.run.id} className="flex min-h-11 items-center gap-3 px-2 py-2">
            <WorkflowIcon className="size-4 shrink-0 text-muted-foreground" aria-hidden />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="truncate text-sm font-medium text-foreground">
                  {entry.rule.name}
                </span>
                <span className="text-xs text-muted-foreground">{humanize(entry.run.status)}</span>
              </div>
              <p className="mt-0.5 text-xs text-muted-foreground">
                {humanize(entry.run.currentStage)} · Updated{" "}
                {formatTaskDateTime(entry.run.updatedAt)}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

function humanize(value: string): string {
  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
